export default "__VITE_ASSET__fe712d4a__"